var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaturnSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 19.5547,
    r: 19.5,
    fill: "#2B7CF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6499 29.7543C16.2499 29.7543 15.8999 29.4043 15.8999 29.0043V6.9043C15.8999 6.5043 16.2499 6.1543 16.6499 6.1543C17.0499 6.1543 17.3999 6.5043 17.3999 6.9043V29.0043C17.3999 29.4043 17.0499 29.7543 16.6499 29.7543Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 31.2543C24.25 31.2543 24.15 31.2543 24.1 31.2043C23 30.9043 21.05 29.7043 21.7 27.2543C21.95 26.3543 22.7 25.5043 23.6 24.5543C25.9 22.0043 27.25 20.1543 24.8 17.4543C24 16.6043 23.15 16.2043 22.1 16.1543C19.6 16.1043 17.2 18.4043 17.2 18.4543C16.9 18.7543 16.4 18.7543 16.1 18.4543C15.8 18.1543 15.8 17.6543 16.1 17.3543C16.2 17.2543 18.9 14.6543 22 14.6543C22.05 14.6543 22.1 14.6543 22.15 14.6543C23.6 14.7043 24.85 15.3043 25.9 16.4543C29.5 20.3543 26.65 23.5043 24.75 25.6043C24.05 26.3543 23.35 27.1543 23.2 27.6543C23.05 28.3043 23.15 28.8543 23.65 29.2543C24.05 29.6043 24.5 29.7043 24.5 29.7043C24.9 29.8043 25.15 30.2543 25.05 30.6543C24.95 31.0543 24.65 31.2543 24.3 31.2543Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.15 12.0039H12.95C12.55 12.0039 12.2 11.6539 12.2 11.2539C12.2 10.8539 12.55 10.5039 12.95 10.5039H20.15C20.55 10.5039 20.9 10.8539 20.9 11.2539C20.95 11.6539 20.6 12.0039 20.15 12.0039Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturnSymbol);
export default __webpack_public_path__ + "static/media/saturn-symbol.04599ed9b6edd8b454b0ca6cf7a9c36e.svg";
export { ForwardRef as ReactComponent };